import cookies from 'js-cookie'
import { ApiConnector } from './api-connector'

export const connector = new ApiConnector(
  fetch,
  cookies,
  document.location,
  window.localStorage
)

export interface Connector {
  get: <TGetResponse = any>(key: string) => Promise<TGetResponse>
  executeDelete: <TDeleteResponse = any>(
    key: string,
    body?: any
  ) => Promise<TDeleteResponse>
  put: <TPutResponse = any>(key: string, body?: any) => Promise<TPutResponse>
  post: <TPostResponse = any>(key: string, body?: any) => Promise<TPostResponse>
}

export interface ThisConnector {
  connector: Connector
}
